import { useRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { FieldValues, useForm as _useForm, UseFormHandleSubmit, UseFormProps } from 'react-hook-form';

const IsFetchingError = new Error('isFetching');

/**
 * TODO: 1차 오픈 이후 react-query와 같은 fetching 라이브러리를 적용 필요 후 제거 필요함
 */
export const useForm = <TFieldValues extends FieldValues = FieldValues, TContext = any>(
  props?: UseFormProps<TFieldValues, TContext>
) => {
  const methods = _useForm<TFieldValues>(props);
  /**
   * method.handleSubmit을 비동기 함수로 작성한 뒤,
   * if(isSubmitting) return; 을 할 경우 isSubmitting 값이 true > false > true ...와 같이 변경되여 중복 호출이 가능해짐
   * 따라서 isSubmitting으로 중복 호출 여부를 판단하지 않고,
   * isFetching을 통해 api 호출 중일때 다시 호출하지 않도록 함
   */
  const isFetching = useRef(false);

  const handleSubmit: UseFormHandleSubmit<TFieldValues> = (onSubmit, onError) => (e) => {
    return methods
      .handleSubmit(async (data) => {
        // api 호출 중일때 다시 호출하지 않음
        if (isFetching.current) {
          // methods.handleSubmit의 나머지 로직을 실행하지 않기 위해 throw
          throw IsFetchingError;
        }

        isFetching.current = true;
        try {
          await onSubmit(data, e);
          isFetching.current = false;
        } catch (e) {
          // api가 실패했을 때 isSubmitting을 false로 변경하기 위해 reset 호출
          methods.reset(undefined, {
            keepDirtyValues: true,
            keepDirty: true,
            keepValues: true,
            keepDefaultValues: true,
            keepTouched: true,
            keepIsValid: true
          });

          isFetching.current = false;
          throw e;
        }
      }, onError)(e)
      .catch((e) => {
        if (e !== IsFetchingError) {
          throw e;
        }
      });
  };

  return {
    ...methods,
    handleSubmit
  };
};
